import React from "react";
import { EMPTY } from "../../configurations/Constants";

function PanelAddedField({
  currentRecord,
  indexValue,
  btnSubmitClick,
  sortedAddedField,
  acres,
  wells,
  noOfFields,
  handleEditClick,
  handleDeleteClick,
  handleHighlightField,
}) {
  const irrig_unit_Id = sortedAddedField.irrig_unit_Id;
  const AddedFieldName = sortedAddedField.fieldName;
  return (
    <div className="p-relative">
      <div className="text-end">
        {btnSubmitClick ? (
          <>
            <span>
              <i className="fa-regular fa-pen-to-square" />
            </span>
            <span>
              <i className="fa-regular fa-trash-can" />
            </span>
          </>
        ) : (
          <>
            <span
              className="cursor-pointer right-30"
              onClick={(e) => {
                handleEditClick(e, irrig_unit_Id, currentRecord);
              }}
            >
              <i className="fa-regular fa-pen-to-square" />
            </span>
            <span
              className="cursor-pointer"
              onClick={(e) => {
                handleDeleteClick(irrig_unit_Id, currentRecord, AddedFieldName);
              }}
            >
              <i className="fa-regular fa-trash-can" />
            </span>
          </>
        )}
      </div>
      <ul key={"fieldsAdded_" + indexValue}>
        <li>
          <a
            className="highlight-field cursor-pointer"
            onClick={(e) => {
              handleHighlightField(e, irrig_unit_Id, currentRecord);
            }}
          >
            {sortedAddedField.fieldName}
          </a>
        </li>
        <li>Certified Acres: {acres}</li>
        <li>Farm:{sortedAddedField.farmName}</li>
        {wells}
        {noOfFields !== 1 &&
        noOfFields > 1 &&
        currentRecord !== noOfFields - 1 ? (
          <hr className="hr-line" />
        ) : (
          EMPTY
        )}
      </ul>
    </div>
  );
}

export default PanelAddedField;
